import { createFileRoute } from '@tanstack/react-router'
import { AIGatewayAuditPage } from '@/features/ai-gateway'

// Restored (compliance-system Decision A11, 14 Sep 2026 follow-up): un-hide the
// AI Gateway page. Was TEMP-HIDDEN 2026-07-03 behind a redirect while pulled from
// the customer app; the nav entry is restored in
// components/layout/data/nav-admin.ts alongside this route.
export const Route = createFileRoute(
  '/_authenticated/_organization/ai-gateway',
)({
  component: AIGatewayAuditPage,
})
